// React and related imports
import React from 'react';

// Date Picker related imports
import DatePicker from 'react-datepicker';

interface DatePickerInputProps {
  selected: Date | undefined;
  selectedDays: Date[];
  onChange: (date: Date | null) => void;
  placeholder: string;
  maxDate?: Date;
  minDate?: Date;
  locale: string;
  className?: string;
  showTimeSelect?: boolean;
  timeFormat?: string;
  timeIntervals?: number;
}

export const DatePickerInput: React.FC<DatePickerInputProps> = ({
  selected,
  selectedDays,
  onChange,
  placeholder,
  maxDate,
  minDate,
  locale,
  className = 'w-44',
  showTimeSelect = false,
  timeFormat = 'HH:mm',
  timeIntervals = 15,
}) => (
  <DatePicker
    icon={
      <svg
        className="me-1 h-4 w-4 text-gray-500 dark:text-gray-400"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
      </svg>
    }
    showIcon={true}
    selected={selected}
    maxDate={maxDate}
    minDate={minDate}
    highlightDates={selectedDays}
    showDateSelect={true}
    onChange={onChange}
    placeholderText={placeholder}
    dateFormat={showTimeSelect ? `dd/MM/yyyy ${timeFormat}` : 'dd/MM/yyyy'}
    showTimeSelect={showTimeSelect}
    timeFormat={timeFormat}
    timeIntervals={timeIntervals}
    locale={locale}
    className={`react-datepicker_Input-padding block rounded-lg border border-gray-300 bg-gray-50 text-sm text-gray-900 focus:border-primary-500 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-primary-500 dark:focus:ring-primary-500 ${className}`}
  />
);
